/**
 * Tiene la barra "Filtra e ordina" agganciata all'header su mobile.
 *
 * Due cose da sapere sul tema:
 * 1. L'header e' gia' sticky: il wrapper .cc-header e' ancorato a top:-1px,
 *    quindi da agganciato il suo bordo inferiore sta a offsetHeight - 1.
 * 2. Sotto i 769px sections/header.liquid nasconde l'header allo scroll verso
 *    il basso aggiungendogli .header--hidden (transform: translateY(-100%)).
 *    Il wrapper pero' resta al suo posto: senza questo script la barra
 *    resterebbe agganciata a 67px con un buco sopra.
 *
 * Si rispecchia quindi lo stato dell'header in una classe su <html>, e il CSS
 * sposta il top della barra fuori campo. Cambiare il top di un elemento sticky
 * non ha effetto finche' non e' agganciato: nessuno scatto quando si scorre
 * nella parte alta della pagina, dove la barra e' ancora nel flusso.
 */
(function () {
  var wrapper = document.querySelector('.cc-header');
  var header = document.querySelector('store-header.header');
  var toolbar = document.querySelector('products-toolbar');
  if (!wrapper || !toolbar) return;

  var root = document.documentElement;

  function measure() {
    var top = Math.max(0, Math.round(wrapper.getBoundingClientRect().height) - 1);
    root.style.setProperty('--lc-sticky-top', top + 'px');
    root.style.setProperty(
      '--lc-sticky-top-out',
      '-' + (Math.round(toolbar.getBoundingClientRect().height) + 8) + 'px'
    );
  }

  function syncHeaderState() {
    root.classList.toggle('lc-header-hidden', header.classList.contains('header--hidden'));
  }

  measure();

  if (header) {
    syncHeaderState();
    new MutationObserver(syncHeaderState).observe(header, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  window.addEventListener('resize', measure, { passive: true });
  document.addEventListener('shopify:section:load', measure);

  if (window.ResizeObserver) {
    var ro = new ResizeObserver(measure);
    ro.observe(wrapper);
    ro.observe(toolbar);
  }
})();
